<template>
  <div>
    <el-form :model="form">
      <el-form-item :label="$t('message.spNo')">
        <el-input v-model="form.spNo" placeholder="" disabled></el-input>
      </el-form-item>
    </el-form>
    <div class="ps_msgBox">
      <div class="ps_msg_failed">
        <div class="failed_text">
          <i class="el-icon-warning"></i>
          <span>{{ $t("message.canNot_afterFile") }}</span>
        </div>
        <div class="failed_reason">
          {{ $t("message.reason") }}
          {{ $t("message.ACCOUNT_MISMATCHED") }}
        </div>
      </div>
    </div>
    <div class="submit_btn">
      <GradientBtn @click="logout">{{
        $t("message.logout_account")
      }}</GradientBtn>
    </div>
  </div>
</template>

<script>
import GradientBtn from "../../../components/GradientBtn";
export default {
  components: { GradientBtn },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    // 登出
    logout() {
      const lang = this.$t("message.lang_account");
      window.location.replace(
        `${process.env.VUE_APP_ACCOUNT_PATH}/${lang}/logout/`
      );
    },
  },
  created() {
    this.form.spNo = localStorage.getItem("searchSpNo") || null;
  },
};
</script>

